module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2022-23.68b1e619.pdf";